<template>
  <div class="view-choice-icon-group">

    <router-link v-if="membership_required" :to="{name: 'MembershipPage'}" class="membership-required-link">
      <img :src="`${$imagePathBase}logo-red-carpet.svg`"/>
      <div class="membership-required-text">
        Members see where to stream<br>
        <i>all</i> films. <b>Learn more <sup><i class="fa fa-external-link"></i></sup></b>
      </div>
    </router-link>

    <div v-else>
      <div v-if="rental_and_purchase_providers?.length" class="provider-type">
        <div class="provider-type-label">rent/buy</div>
        <span v-for="prov in rental_and_purchase_providers" :key="`rentbuy-${prov.id}`">
          <span data-toggle="tooltip" :title="prov.name">
            <img :src="prov.logo_path" class="watch-provider-icon">
          </span>
        </span>
      </div>
      <div v-if="subscription_providers?.length" class="provider-type">
        <div class="provider-type-label">sub</div>
        <span v-for="prov in subscription_providers" :key="`sub-${prov.id}`">
          <span data-toggle="tooltip" :title="prov.name">
            <img :src="prov.logo_path" class="watch-provider-icon">
          </span>
        </span>
      </div>
      <div v-if="free_providers?.length" class="provider-type">
        <div class="provider-type-label">free</div>
        <span v-for="prov in free_providers" :key="`free-${prov.id}`">
          <span data-toggle="tooltip" :title="prov.name">
            <img :src="prov.logo_path" class="watch-provider-icon">
          </span>
        </span>
      </div>
    </div>

<!--
    <a v-if="imdb_link" class="watch-provider-icon" :href="imdb_link" title='IMDB' target='blank'>
      <span style="font-size: 11.5px;" class='fa-stack'>
        <i style="color: black;" class='fa fa-stack-2x fa-square'></i>
        <i style="color: #F5C518;" class='fa fa-stack-2x fa-imdb'></i>
        <i style="opacity: 80%;padding-bottom: 9px;bottom: 0px;top: -10;top: -10;padding-left: 16px;" class="fa fa-stack-1x fa-external-link"></i>
      </span>
    </a>
-->
  </div>
</template>


<script>
export default {
  name: "ViewChoiceIcons",
  props: ['membership_required', 'subscription_providers', 'rental_and_purchase_providers', 'free_providers', 'imdb_link'],
  inject: ['closeModal'],
  created() {
    //console.log('streaming_providers', this.streaming_providers);
  }
}
</script>

<style scoped>


.view-choice-icon-group {
  /*margin-top: 10px;*/
  padding-left: 0;
  padding-right: 0;
  text-align: right;
}

.watch-provider-icon {
  width:20px;
  height:20px;
  border-radius: 25%;
  margin-top: 2px;
  margin-bottom: 2px;
  margin-right: 2px;
  margin-left: 2px;
}

.provider-type {
  position: relative;
  display: inline-block;
  border: solid;
  border-width: thin;
  border-color: lightgray;
  border-radius: 6px;
  margin: 2px;
  text-align: center;
  padding: 1px;

  .provider-type-label {
    /*
    position: absolute;
    bottom: 24px;
    */

    /*color: darkslategrey;*/
    text-align: center;
    margin: 2px;

    font-size: 8px;
    line-height: 0.9em;

  }
}

.membership-required-link {

  color: var(--mol-color-red-carpet);
  font-size: 10px;

  position: relative;
  display: inline-block;
  border: solid;
  border-width: thin;
  border-color: var(--mol-color-red-carpet-faded);
  border-radius: 6px;
  margin: 2px;
  text-align: center;
  padding: 1px 4px 3px 4px;

  text-decoration: inherit;

  img {
    margin-top: 6px;
    height: 20px;
    vertical-align: top;
  }

  .membership-required-text {
    margin-left: 3px;
    display: inline-block;
  }

  &:hover {
    background-color: var(--mol-color-red-carpet-background);
  }

}


</style>